import { render, staticRenderFns } from "./AccountLinkFragment.vue?vue&type=template&id=b47808e8&"
import script from "./AccountLinkFragment.vue?vue&type=script&lang=js&"
export * from "./AccountLinkFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports